import { useRef } from "react";

export function KeepAlive({ active, children }: { active: boolean, children: React.ReactNode }) {
  const ref = useRef<React.ReactNode>(children);
  if (active) ref.current = children;
  return (
    <div style={{ display: active ? "block" : "none", width: "100%", height: "100%" }}>
      {ref.current}
    </div>
  );
} 